import "babel-polyfill";
import "isomorphic-fetch";
import Menu from './modules/Menu';
import EtaSlider from './modules/EtaSlider';
import MenuWatcher from './modules/MenuWatcher';
import Intro from './modules/Intro';
import Sliders from './modules/Sliders';
import Slider from './modules/Slider';
import Map from './modules/GMap';
import ReadMore from './modules/ReadMore';
import Search from './modules/Search';
import './app.sss';


class Index {
  constructor() {
    Menu();
    
    new Map({
      disableDefaultUI: false,
      zoom: 10
    });

    Intro(() => {
      new Search();
      new EtaSlider();
      new MenuWatcher();
      new Slider('.small_slides_widget');
      ReadMore();
      const sliders = new Sliders('.slide_imgs');
      this.constrollers();
    });
    
  }

  constrollers() {
    
  }
}


window.addEventListener('load', new Index());
